import React from 'react'
import MenuItem from 'material-ui/MenuItem'
import config from '../../config'
const buildMenuItems = resource => {
  let partialPath = ''
  if (resource.type !== 'guest') {
    partialPath = `/${resource.type}s/${resource.series_id}`
  }
  const menuItems = [
    <MenuItem
      primaryText='Edit'
      key='edit'
      value={`/events${partialPath}/webinars/${resource.id}/edit`}
    />,
    <MenuItem key='View'>
      <a
        style={{ color: 'inherit', textDecoration: 'none' }}
        href={`${config.webUrl}webinars/${resource.slug}`}
        target='_blank' rel="noreferrer"
      >
        View Webinar
      </a>
    </MenuItem>
  ]

  return menuItems
}

export default buildMenuItems
